/**
 * Override/patch these functions for testing
 */

// In tests, we need to disable virtualization; otherwise not all of the rows will be rendered.
// https://github.com/mui/mui-x/issues/8697
// https://mui.com/x/react-data-grid/virtualization/#disable-virtualization
export const doDisableVirtualization = () => false;
